import { render, staticRenderFns } from "./RequestPasswordForm.vue?vue&type=template&id=776126d9&scoped=true&"
import script from "./RequestPasswordForm.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestPasswordForm.vue?vue&type=style&index=0&id=776126d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776126d9",
  null
  
)

export default component.exports